import { render, staticRenderFns } from "./Handoff.container.vue?vue&type=template&id=70ce46de&scoped=true&"
import script from "./Handoff.container.vue?vue&type=script&lang=ts&"
export * from "./Handoff.container.vue?vue&type=script&lang=ts&"
import style0 from "./Handoff.container.vue?vue&type=style&index=0&id=70ce46de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce46de",
  null
  
)

export default component.exports